export const selfSelector = (state) => state.clients;